import { Drawer } from "../Drawer";
import { trpc } from "../../lib/trpc";
import { Icon } from "../ui/Icon";

interface MovementTimelineProps {
  open: boolean;
  lotId: string | null;
  lotCode?: string;
  onClose: () => void;
}

const TYPE_META: Record<string, { label: string; color: string }> = {
  receipt: { label: "Mal Kabul", color: "var(--success)" },
  consumption: { label: "Tüketim", color: "var(--danger)" },
  transfer: { label: "Transfer", color: "var(--info)" },
  production: { label: "Üretim", color: "var(--success)" },
  scrap: { label: "Fire", color: "var(--danger)" },
  adjustment: { label: "Düzeltme", color: "var(--warning)" },
  shipment: { label: "Sevkiyat", color: "var(--neutral-700)" },
  reservation: { label: "Rezervasyon", color: "var(--info)" },
  return: { label: "İade", color: "var(--success)" },
  count_diff: { label: "Sayım Farkı", color: "var(--warning)" },
};

function fmtDateTime(d: Date | string): string {
  const dt = typeof d === "string" ? new Date(d) : d;
  return new Intl.DateTimeFormat("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).format(dt);
}
function fmtQty(n: number): string {
  const s = new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 3, signDisplay: "always" }).format(n);
  return s;
}

export function MovementTimelineDrawer({ open, lotId, lotCode, onClose }: MovementTimelineProps) {
  const movesQ = trpc.inventory.movements.useQuery(
    { lotId: lotId!, page: 1, pageSize: 100 },
    { enabled: open && !!lotId }
  );
  const rows = movesQ.data?.rows ?? [];

  return (
    <Drawer open={open} onClose={onClose} title="Lot Hareket Geçmişi" subtitle={lotCode ? `Lot: ${lotCode}` : undefined}>
      {movesQ.isLoading ? (
        <div className="d-empty">
          <Icon name="clock" size={26} />
          <span className="m">Yükleniyor…</span>
        </div>
      ) : rows.length === 0 ? (
        <div className="d-empty">
          <Icon name="inbox" size={26} />
          <span className="m">Bu lot için hareket yok.</span>
        </div>
      ) : (
        <div className="list-card">
          {rows.map((m) => {
            const meta = TYPE_META[m.movementType] ?? { label: m.movementType, color: "var(--neutral-500)" };
            const isPositive = m.qty >= 0;
            const detail = [m.referenceType, m.reasonCode, m.notes].filter(Boolean).join(" · ");
            return (
              <div key={m.id} className="list-item">
                <span style={{ width: 10, height: 10, borderRadius: "50%", background: meta.color, flexShrink: 0 }} aria-hidden="true" />
                <div className="body">
                  <div className="t">
                    <span style={{ fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.04em", color: meta.color, fontSize: 10.5 }}>{meta.label}</span>
                    <span style={{ color: "var(--neutral-400)", margin: "0 6px" }}>·</span>
                    <span className="mono" style={{ fontSize: 11.5, color: "var(--neutral-700)" }}>{m.locationCode}</span>
                  </div>
                  <div className="s">{m.itemCode} {m.itemName}</div>
                  {detail ? <div className="s">{detail}</div> : null}
                </div>
                <div className="amount" style={{ textAlign: "right" }}>
                  <div style={{ fontWeight: 600, fontSize: 13, color: isPositive ? "var(--success)" : "var(--danger)" }}>
                    {fmtQty(m.qty)}
                  </div>
                  <div style={{ fontSize: 10.5, color: "var(--neutral-400)", marginTop: 2 }}>{fmtDateTime(m.ts)}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Drawer>
  );
}
